export default __webpack_public_path__ + "static/media/genetic-and-developmental-diseases.79c189c3.svg";